import { useState, useEffect } from 'react';

import { getPricingPageAdditionalContent } from './client/fetch.ts';
import {
	mapAdditionalContentToTableData,
	MappedTableData,
	PricingPageAdditionalContentData,
} from './client/table-data-mapper.ts';

interface UseTableDataArgs {
	urlSlug: string;
	locale: string;
}

interface UseTableDataResult {
	tableData: MappedTableData['features'];
	planTitles: string[];
	hasError: boolean;
}

export const useTableData = ({ urlSlug, locale }: UseTableDataArgs): UseTableDataResult => {
	const [tableData, setTableData] = useState<MappedTableData['features']>([]);
	const [planTitles, setPlanTitles] = useState<string[]>([]);
	const [hasError, setHasError] = useState(false);

	useEffect(() => {
		getPricingPageAdditionalContent({ urlSlug, locale })
			.then((data) => {
				if (data) {
					const { features, planTitles: fetched } = mapAdditionalContentToTableData(
						data as PricingPageAdditionalContentData,
					);
					setTableData(features);
					setPlanTitles(fetched);
				}
			})
			.catch(() => {
				setHasError(true);
			});
	}, []);

	return { tableData, planTitles, hasError };
};
